import { render, staticRenderFns } from "./ForgetPasswordV2.vue?vue&type=template&id=27c8323d&"
import script from "./ForgetPasswordV2.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports